<template>
  <v-layout>
    <v-flex>
      <div class="text-right mb-6">
        <v-btn
          class="ml-md-10"
          dark
          large
          depressed
          color="primary"
          :to="{ name:'booking', params: { id: 'add' } }"
        >
          <v-icon dark class="mr-2">
            mdi-plus
          </v-icon>
          <span class="mx-4">Create New Booking</span>
        </v-btn>

      </div>
      <v-card class="pa-6 pt-4 mt-10">
        <v-card-title>
          Bookings
          <v-spacer></v-spacer>
          <v-select
            v-model="status"
            :items="statuses"
            @change="filterBy"
            menu-props="auto"
            label="Status"
            item-text="name"
            class="max-width-300 mr-10"
            prepend-icon="mdi-filter-outline"
            item-value="id"
            hide-details
          >
          </v-select>

          <v-text-field
            v-model="search"
            class="table-search"
            append-icon="mdi-magnify"
            label="Search"
            hide-details>
          </v-text-field>
        </v-card-title>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="bookings"
          :server-items-length="pagination.total"
          :items-per-page="pagination.per_page"
          :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
          :loading="loading"
          loading-text="Loading Bookings..."
          item-key="id"
          no-data-text="No Bookings Found"
          :options.sync="options"
          :item-class="itemRowBackground"
          ref="table">

          <template v-slot:[`item.shipping_mark`]="{ item }">
            <v-icon
              size="24"
              class="mr-2">
              {{ isShipmentForSea(item.shipment_type) ? 'mdi-ferry' : 'mdi-airplane' }}
            </v-icon>
            {{ item.shipping_mark }}
          </template>

          <template v-slot:[`item.name`]="{ item }">
            {{ item.first_name + ' ' + item.last_name }}
          </template>

          <template v-slot:[`item.total_qty`]="{ item }">
            {{ formatNumber(item.total_qty) }}
          </template>

          <template v-slot:[`item.total_cbm`]="{ item }">
            <span v-if="isShipmentForSea(item.shipment_type)">{{formatNumber(item.total_cbm) }} CBM</span>
            <span v-if="!isShipmentForSea(item.shipment_type)">{{formatNumber(item.total_kg) }} KG</span>
          </template>

          <template v-slot:[`item.sales_agent`]="{ item }">
            <v-icon
              size="24"
              class="mr-1">
              mdi-face-agent
            </v-icon>

            {{ getAgentName(item.sales_agent) }}
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <BookingStatusLabel :status="item.status" :small="true" :statuses="statuses"></BookingStatusLabel>
          </template>

          <template v-slot:[`item.created_at`]="{ item }">
            {{ item.created_at | moment("MM-D-YYYY") }}
          </template>


          <template v-slot:item.action="{ item }">

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  class="mr-2"
                  color="primary"
                  @click="viewItem(item.id)">
                  mdi-file-document-outline
                </v-icon>
              </template>
              <span>View</span>
            </v-tooltip>

            <v-tooltip bottom v-if="item.status == 0">
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="red darken-2"
                  @click="deleteItem(item)">
                  mdi-delete
                </v-icon>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>




      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
      <ConfirmationDialog
        :dialog="dialog"
        @doConfirm="doConfirm"
        @doCancel="doCancel"
      >
      </ConfirmationDialog>
    </v-flex>
  </v-layout>

</template>

<script>
  import { mapGetters } from "vuex";
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import ConfirmationDialog from '@/components/dialog/ConfirmationDialog.vue'
  import BookingStatusLabel from '@/components/BookingStatusLabel.vue'

  export default {
    name: 'ClientBookingList',
    data() {
      return {
        snackbarDetails: {
          color: 'sb-success',
          msg: '',
          show: false
        },
        dialog: {
          show: false,
          title: 'Delete Item',
          body: 'Are you sure you want to delete this item?',
          type: '',
          item: {},
          confirmBtn: 'Yes',
          cancelBtn: 'Cancel'
        },
        error:{
          show: false,
          status: '',
          error: '',
          messages: {}
        },
        firstLoad: true,
        loading: false,
        search: '',
        awaitingSearch: false,
        selected: [],
        status: '',
        statuses: [],
        bookings: [],
        agents: [],
        pagination: {
          page: 1,
          per_page: 1,
          total: 0,
          next: 0
        },
        options: {},
        headers: [
          {
            text: 'Shipping Mark',
            align: 'start',
            value: 'shipping_mark',
            sortable: false,
            width: 240
          },
          {
            text: 'Description',
            align: 'start',
            value: 'details',
            sortable: false
          },
          {
            text: 'Total Qty',
            align: 'right',
            value: 'total_qty',
            sortable: false,
            width: 90
          },
          {
            text: 'Total CBM/KG',
            align: 'right',
            value: 'total_cbm',
            sortable: false,
            width: 120
          },
          {
            text: 'Sales Agent',
            align: 'start',
            value: 'sales_agent',
            width: 180,
            sortable: false
          },
          // {
          //   text: 'Created Date',
          //   align: 'start',
          //   value: 'created_at',
          //   width: 90,
          //   sortable: false
          // },
          {
            text: 'Status',
            align: 'center',
            value: 'status',
            sortable: false,
            width: 70,
          },
          {
            text: 'Action',
            value: 'action',
            sortable: false,
            width: 90
          }
        ]
      }
    },
    computed: {
      ...mapGetters(['getUserInitial', 'formatNumber', 'formatNumberAmount', 'forSea']),
      hasSelected: function(){
        return this.selected.length != 0 ? false : true
      }
    },
    watch: {
      options: {
        handler () {
          this.getBookings()
        },
        deep: true,
      },
      search: function (val) {
        if (!this.awaitingSearch) {
          setTimeout(() => {
            this.options.page = 1
            this.getBookings()
            this.awaitingSearch = false;
          }, 1000); // 1 sec delay
        }
        this.awaitingSearch = true;
      },
    },
    methods: {
      filterBy (id) {
        this.status = id
        this.options.page = 1
        this.getBookings()
      },
      isShipmentForSea (shipment_type){
        return this.forSea(shipment_type, this)
      },
      itemRowBackground: function (item) {
         return item.sales_agent > 0 ? '' : 'bg-lightblue'
      },
      getAgentName: function(id){
        let agents = this.agents.filter(agent => {
          return agent.id == id
        })
        if(agents.length > 0){
          let agent = agents[0]
          return agent.first_name + ' ' + agent.last_name
        }
      },
      getStatusName: function(id){
        let statuses = this.statuses.filter(status => {
          return status.id == id
        })
        if(statuses.length > 0){
          return statuses[0].name
        }
      },
      getDefaultData () {
        let self = this
        this.$http.plain.get('/default-data?booking_statuses=true&agents=true')
          .then(response => {
            let allowedStatuses = [
              '',
              this.$getConstBookingStatus('BOOKING_STATUS_PENDING'),
              this.$getConstBookingStatus('BOOKING_STATUS_AGENT_VIEWED'),
              this.$getConstBookingStatus('BOOKING_STATUS_ONGOING'),
              this.$getConstBookingStatus('BOOKING_STATUS_COMPLETED'),
              this.$getConstBookingStatus('BOOKING_STATUS_CANCELLED')
            ]

            response.data.booking_statuses.forEach(obj => {
              if(allowedStatuses.includes(obj.id)) this.statuses.push(obj)
            })

            this.agents = response.data.agents
          })
          .catch(error => {
            console.log(error);
          })
      },
      doConfirm () {
        this.dialog.show = false
        this.confirmDeleteItem()
      },
      doCancel () {
        this.dialog.show = false
      },
      deleteItem (item) {
        this.dialog = {
         show: true,
         title: 'Delete Booking',
         body: 'Are you sure you want to delete '+item.shipping_mark+' booking?',
         type: 'close',
         item: item,
         confirmBtn: 'Yes',
         cancelBtn: 'No'
        }
      },
      confirmDeleteItem () {
        let self = this

        this.$http.secured.delete('/bookings/'+ this.dialog.item.id)
          .then(response => {
            if(response.data){

              this.showMessage(this.dialog.item.shipping_mark + " has been successfully deleted", 'success')

              if(this.options.page > 1) {
                  this.options.page = 1
                  return false
              }

              this.getBookings()

            }
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(error.response.data.error, 'error')
              this.error.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
            self.dialog.show = false
          })

      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      viewItem (id) {
        this.$router.push({ name: 'booking-view', params: { id: id } })
      },
      getBookings () {
        if (this.loading) {
          return false
        }

        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        let sorting = []
        let params = []

        if (sortBy.length === 1 && sortDesc.length === 1) {
          sortBy.forEach(function (item, index) {
            let sort = 'ASC'
            if (!sortDesc[index]) {
              sort = 'DESC'
            }
            sorting.push(item+'='+sort)
          });
        }

        params = { page: page, per_page: itemsPerPage }
        if (this.search.length > 0) params.search = this.search
        if (this.status.length > 0) params.status = this.status

        if(!this.firstLoad){
          this.$router.push({ name: 'bookings-page', params: { page: page }})
        }

        this.firstLoad = false

        this.loading = true
        let self = this
        this.$http.plain.get('/bookings', { params: params })
          .then(response => {
            this.bookings = response.data.bookings

            if (response.data.pagination) {
              let pagination = response.data.pagination

              this.pagination.total = pagination.count
            }

          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
        }
    },
    mounted() {
      if(this.$route.query.added){
        this.showMessage(this.$route.query.message, 'success')
        this.$router.push({ name: 'bookings' })
      }

      if(this.$route.params.page){
        this.options.page = parseInt(this.$route.params.page)
      }

      if(this.$route.query.status){
        this.status = this.$route.query.status
      }

      this.getDefaultData()

    },
    components: {
      SnackBar,
      ConfirmationDialog,
      BookingStatusLabel
    },
  }
</script>
